import type * as React from "react";

import { cn } from "../lib/cn";

export interface LabelTapeProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** The name punched into the tape. Two or three words at most. */
  children: React.ReactNode;
  ref?: React.Ref<HTMLSpanElement>;
}

/**
 * A strip of embossed label-maker tape: white letters punched into black
 * plastic. Used for the names of physical things in the clinic - rooms, kennels,
 * machines, the computer running Hans. Someone walked over and stuck a label on
 * it, and it has said the same thing ever since.
 *
 * Names only. Tape is not a status and not a button: it never carries a state
 * word (that is a Swipe) and never responds to a click.
 */
export function LabelTape({ children, className, ...rest }: LabelTapeProps) {
  return (
    <span
      className={cn(
        "inline-block rounded-[2px] bg-ink px-2 py-1",
        "font-mono text-[0.6875rem] font-medium uppercase tracking-[0.13em] text-ink-inverse",
        // embossed plastic: a lit top edge and a shaded bottom one, nothing else
        "shadow-[inset_0_1px_0_rgba(255,255,255,0.12),inset_0_-1px_0_rgba(0,0,0,0.4)]",
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  );
}
